export const tagColorMap = {
  deal: 'bg-blue-4',
  ev: 'bg-grey-1',
  hold: 'bg-yellow-3',
  locked: 'bg-red-2',
  price: 'bg-green-2',
  recent: 'bg-marketplace-purple',
  reservable: 'bg-blue-2'
};

export const tagTextMap = {
  locked: 'Purchase in Progress',
  hold: 'On Hold',
  recent: 'Recently Added',
  reservable: 'Pre-Order Now'
};

export enum Tag {
  Deal = 'deal',
  Ev = 'ev',
  Hold = 'hold',
  Locked = 'locked',
  Price = 'price',
  Recent = 'recent',
  Reservable = 'reservable'
}
